import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppBar, DialogActions, DialogContent, Divider, IconButton, Toolbar, Typography } from '@mui/material';
import { FormikProvider } from 'formik';
import { observer } from 'mobx-react-lite';
import { Fragment, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useService } from '~/services/service.base';
import { MediaSearchService } from '~/services/service.media.search';
import { UIService } from '~/services/service.ui';
import { useFormikModel } from '~/tools/formik.model';
import { plainToModel } from '~/tools/plain.model';
import { Button } from '~/views/atoms/button';
import { Icons } from '~/views/atoms/icons';
import { FormMediaSearchVisitor } from '~/views/molecules/form-media-search-visitor/form.media.search.visitor';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '~/routes/routes';
import { validatorVisitorSearch } from '~/views/organisms/search/visitor-search/validator.visitor.search';
import { SearchVisitorModel } from '~/models/model.search.visitor';
const sxToolbar = { height: UIService.TOOLBAR_SEARCH_HEIGHT, justifyContent: 'space-between', gap: 1 };
export const VisitorSearch = observer(() => {
    const { t } = useTranslation();
    const mediaSearchService = useService(MediaSearchService);
    const { searchFieldSvc, handleClickBack } = mediaSearchService;
    const navigate = useNavigate();
    const onSubmit = useCallback((data) => {
        const searchParams = JSON.stringify({
            name: data.fileName,
            description: data.owner,
            depository_id: data.depository?.id,
        });
        mediaSearchService.setOrder('title ASC');
        mediaSearchService.resetData();
        mediaSearchService.setFilterType(undefined);
        mediaSearchService.setQuery(searchFieldSvc.value);
        mediaSearchService.getMediaItems({ offset: 0, limit: 10, page: 1 }, searchParams);
        mediaSearchService.openSearchSvc.handleClose();
        mediaSearchService.openDialogSvc.handleClose();
        navigate(ROUTES.FUNDS.MEDIA.SEARCH_RESULT.path, { state: { searchParams, query: undefined } });
    }, [mediaSearchService, navigate, searchFieldSvc.value]);
    const resetFilterForm = useCallback(() => {
        mediaSearchService.resetData();
        searchFieldSvc.handleClear();
        mediaSearchService.openDialogSvc.handleClose();
        mediaSearchService.openSearchSvc.handleClose();
        navigate(ROUTES.FUNDS.path);
    }, [mediaSearchService, navigate, searchFieldSvc]);
    const initialValues = useMemo(() => plainToModel(SearchVisitorModel, {}), []);
    const formik = useFormikModel(SearchVisitorModel, {
        initialValues,
        onSubmit,
        validateOnMount: true,
        validateOnChange: true,
        validate: validatorVisitorSearch,
    });
    return (_jsxs(FormikProvider, { value: formik, children: [_jsxs(AppBar, { color: "inherit", position: "relative", children: [_jsxs(Toolbar, { sx: sxToolbar, children: [_jsx(IconButton, { color: "inherit", onClick: handleClickBack, children: _jsx(Icons.Back, {}) }), _jsxs(Fragment, { children: [_jsx(Typography, { variant: "h2", children: t('SEARCH_DIALOG_INFO_SHEET') }), _jsx(IconButton, { color: "inherit", onClick: resetFilterForm, children: _jsx(Icons.Close, { color: "primary" }) })] })] }), _jsx(Divider, {})] }), _jsx(DialogContent, { children: _jsx(FormMediaSearchVisitor, {}) }), _jsx(DialogActions, { children: _jsx(Button, { disabled: !formik.isValid, fullWidth: true, onClick: formik.submitForm, children: t('SEARCH_DIALOG_SEARCH') }) })] }));
});
